import React from 'react';
import Button from "../../components/Button";
import { Box } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Message from "../../components/Message";
import { Link } from 'react-router-dom';
import { getGiftRedemptionState } from "../../utils/gift";

const useStyles = makeStyles(theme => createStyles({
    dialogTitle: {
        color: 'white',
        textAlign: 'center'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        zIndex: 1,
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    button: {
        maxWidth: '400px'
    },
    egift: {
        color: 'white !important',
        '&:hover': {
            color: `${theme.palette.secondary.main} !important`
        }
    }
}));

export const getUrl = (gift) => {
    let url = `/secure/gift/${gift.id}`;

    if (gift.gift_type === 'egift') {
        url = `/secure/egift/${gift.id}`;
    }
    if (gift.date_exchanged) {
        url = `${url}?redirect=none`;
    }
    return url;
};

export default function({gift}) {
    const classes = useStyles();

    let warning = false;
    let className = 'giftya';
    let text = 'View GiftYa';
    let variant = 'outlined';
    let color = 'secondary';
    let notDelivered = false;
    let component = 'button';


    if (gift.gift_type === 'egift') {
        text = 'View eGift';
        variant = 'contained';
        color = 'secondary';
        className = 'egift';
    }

    if (
        gift.viewer_is_recipient
        && gift.gift_type !== 'egift'
        && !gift.linked_card_id
        && !(gift.date_redeemed || gift.status === 'used')
        && (!gift.linked_card_error || !gift.linked_card_error)
        && (!gift.gift_ya_select || (gift.gift_ya_select && gift.gift_ya_select_merchant_selected))
    ) {
        text = 'Activate GiftYa';
        warning = true;
        color = 'secondary';
        variant = 'contained';
        component = Link;
    }

    if (
        gift.viewer_is_recipient
        && !gift.linked_card_id
        && !gift.date_redeemed
        && !gift.linked_card_error
        && gift.gift_ya_select
        && !gift.gift_ya_select_merchant_selected
    ) {
        text = 'Select merchant';
    }

    if (
        gift.viewer_is_recipient
        && gift.linked_card_error
        && gift.gift_type !== 'egift'
    ) {
        warning = true;
        color = 'error';
        variant = 'contained';
        text = 'Activate GiftYa';
        component = Link;


    }

    if (gift.viewer_is_sender && gift.delivery_failed) {
        text = 'Try again';
        notDelivered = true;
        variant = 'contained';
        color = 'secondary';
    }

    if (gift.viewer_is_sender && gift.date_redeemed) {
        text = 'Reorder';
    }

    if (gift.viewer_is_sender && !gift.date_failed && !gift.date_first_viewed && !gift.date_defunded && !gift.date_refunded && !notDelivered) {
        text = 'Not opened';
        warning = true;
        color = 'warning';
        variant = 'contained';
    }

    const giftRedemptionState = getGiftRedemptionState({gift});

    return (
        <Box mt={2}>
            {notDelivered && (
                <Box mb={1} maxWidth={400}>
                    <Message>NOT DELIVERED</Message>
                </Box>
            )}
            <Button
                className={`${classes.button} ${classes[className]} view-button`}
                href={getUrl(gift)}
                to={getUrl(gift)}
                color={color}
                variant={variant}
                fullWidth={true}
                component={component}
                endIcon={warning && (<ErrorOutlineIcon />)}
                data-redemption-state-can-send-reminder={giftRedemptionState.canSendReminder}
                data-redemption-state-can-update-balance={giftRedemptionState.canUpdateBalance}
                data-redemption-state-can-manage-gift={giftRedemptionState.canManageGift}
                data-redemption-state-can-view-egift-card-button={giftRedemptionState.canViewEgiftCardButton}
                data-redemption-state-show-delivery-failed-message={giftRedemptionState.showDeliveryFailedMessage}
                data-redemption-state-show-egift-processing-message={giftRedemptionState.showEgiftProcessingMessage}
                data-redemption-state-can-show-remaining-balance={giftRedemptionState.canShowRemainingBalance}
                data-redemption-state-show-redemption-options={giftRedemptionState.showRedemptionOptions}
                data-redemption-state-can-show-history={giftRedemptionState.canShowHistory}
                data-redemption-state-can-send-thank-ya={giftRedemptionState.canSendThankYa}
                data-redemption-state-is-mc-visa={giftRedemptionState.isMcVisa}
            >
                {text}
            </Button>
        </Box>
    );
}
